export const environment = {
  production: false,
  hostUrl: 'https://uat-kbank-dinning.vthgdigital.com',
  apiUrl: 'https://uat-kbank-dinning.vthgdigital.com/api/',
  feRedirectUrl: 'https://uat-kbank-dinning.vthgdigital.com/',
};
